module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "cpp20"
  }, [_c('span', {
    staticClass: "cpp8"
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "cpp23er"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "cpp10"
  }, [_vm._v("n compiling this book I have received help and support from many people. Although they are far too numerous to mention in full, I would specifically like to thank the following:")])]), _vm._v(" "), _c('p', {
    staticClass: "cpp24"
  }, [_c('span', {
    staticClass: "cpp10"
  }, [_vm._v("Rachel Conroy, Curator of Temple Newsam House; Kitty Ross, Curator of the Abbey House Museum; Lucy Moore, Projects Curator for Leeds Museums; Lord Halifax; Julie Holroyd and Adrian Thompson, Visitor Assistants at Temple Newsam House; Derek Voller; Lis Burke; Neil Clifton; Richard Thomson; David Pacey; The West Yorkshire Archive Service; The Borthwick Institute; The Thoresby Society; Imperial War Museums, London; The British Red Cross Archives; The Shakespeare Birthplace Trust Archives; The Leeds Library; The Royal Archives; Heritage Technology Ltd; members of the general public and, of course, my wife Linda – for her endless patience.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2355efb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Chapter_1.vue
// module id = 72
// module chunks = 0